<template>
  <div>
    <metainfo>
      <template #title="{ content }">
        {{ content ? `${content} - Compass` : `Compass` }}
      </template>
    </metainfo>

    <progress-bar-loading
      v-if="isProgressShown"
      class="fixed top-0 left-0 z-10000 w-full"
    />

    <app-shell>
      <router-view />
    </app-shell>

    <ui-dialog />

    <connect-wallet-modal
      class="z-50"
      @ready="isReady = true"
      @error="onAuthError"
    />

    <premium-modal ref="premiumModal" />
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
  provide,
} from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useProgressBarLoading } from "@/composition/progress-bar-loading";
import blockNumberQuery from "@/graphql/meta/queries/blockNumber.query.gql";
import blockHeadSubscription from "@/graphql/meta/subscriptions/blockHead.subscription.gql";
import eventBus from "@/utils/event-bus";
import routesNames from "@/router/routesNames";


import AppShell from "@/components/AppShell2.vue";
import UiDialog from "@/components/ui-dialog/UiDialog.vue";
import ConnectWalletModal from "@/components/ConnectWalletModal.vue";
import LoadingIndicator from './components/LoadingIndicator.vue';
import PremiumModal from './components/PremiumModal.vue';
import HelpWidget from './components/HelpWidget.vue';
import LiveBadge from './components/LiveBadge.vue';
import ProgressBarLoading from "@/components/ProgressBarLoading.vue";

export default defineComponent({
  components: {
    ConnectWalletModal,
    UiDialog,
    AppShell,
    LoadingIndicator,
    PremiumModal,
    HelpWidget,
    LiveBadge,
    ProgressBarLoading,
  },

  metaInfo() {
    return {
      title: "Compass",
      htmlAttrs: {
        lang: "en",
        amp: false,
      },
    }
  },

  setup() {
    const {
      result: blockHeadResult,
      subscribeToMore,
    } = useQuery(blockNumberQuery);

    const {
      isProgressShown,
    } = useProgressBarLoading();

    const blockHead = computed(() => {
      return blockHeadResult.value?.meta.eth.lastBlockSynced;
    });

    provide("eth:blockHead", blockHead);

    subscribeToMore({
      document: blockHeadSubscription,
      updateQuery(previousResult, { subscriptionData }) {
        if (!previousResult || !previousResult?.meta) {
          return {
            meta: {
              eth: {
                lastBlockSynced: subscriptionData.data.blockHead,
              }
            }
          }
        }
        const data = JSON.parse(JSON.stringify(previousResult));
        data.meta.eth.lastBlockSynced = subscriptionData.data.blockHead;
        return data;
      }
    });

    return {
      isProgressShown,
      routesNames
    }
  },

  data() {
    return {
      isReady: true,
      longWaitTimeout: null,
      loadingMessage: null,
      showStatusPage: false
    };
  },
  watch: {
    isReady(value) {
      if (!value) {
        return;
      }

      if (!this.longWaitTimeout) {
        return;
      }

      clearTimeout(this.longWaitTimeout);
    }
  },
  mounted() {
    if (this.$route.query.init_checkout) {
      this.$refs.premiumModal.show(this.$route.query.init_checkout);
    }
    eventBus.$on('auth:showPremiumModal', (action) => {
      if (this.$store.getters['auth/isPremium']) {
        return;
      }

      const showModal = () => {
        this.$refs.premiumModal.show();
        this.$gtag.event('show premium modal', {
          event_category: 'premium lock',
          event_label: action,
        });
      }
      if (!this.$store.getters['auth/isLoggedIn']) {
        eventBus.$emit('auth:signIn');
        eventBus.$on('auth:didSignIn', () => {
          if (this.$store.getters['auth/isPremium']) {
            return;
          }

          showModal();
        });
        return;
      }

      showModal();

    });
  },
  methods: {
    onAuthError() {

    }
  },
});
</script>
